import {
  App,
  AppContext,
  createVNode,
  render,
  getCurrentInstance,
  pushScopeId,
  popScopeId
} from 'vue';
import { TenantContextProvider } from './types';
import { setTenantContext } from './TenantContext';
import { showError } from './Common';
import { RemotePersistApi, setRemotePersistApi } from './LayoutPersistent';
import { setCmdRightProvider, CmdRightProvider } from './CmdRightsControl';
import { vImageView } from '../common/widget/ImageViewer';
import { VueComponentFactory } from 'ag-grid-vue3/lib/VueComponentFactory';
import { VueFrameworkComponentWrapper } from 'ag-grid-vue3/lib/VueFrameworkComponentWrapper';
import { clone, assign } from 'lodash-es';

import EyMessageBox from '../common/popup/messageBox';

import { ElDrawer } from 'element-plus';

import { ApiProtocol, setApiProtocol } from './ApiProtocol';
import { SendBeaconHandle, setBeaconHandle } from './beacon';
import { UiTheme, setUiTheme } from './uiTheme';
import { vSearchScrollArea } from '../search/extend/SearchScrollArea';

import {
  AgHeaderContextMenuExt,
  setExtensionMenus
} from '../common/tab/AgContextMenu.tsx';

////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
// 修改ag-table bug
VueComponentFactory.mount = (
  component: any,
  props: any,
  _parent: any,
  appContext: any
) => {
  // 设置scopeId
  const scopeId =
    component.__scopeId || (component.extends && component.extends.__scopeId);
  scopeId && pushScopeId(scopeId);

  let vNode: any = createVNode(component, props);
  scopeId && popScopeId();

  // 直接使用前端准备好的appContext
  vNode.appContext = appContext;

  let el: any = document.createElement('div');
  render(vNode, el);

  const destroy = () => {
    if (el) {
      render(null, el);
    }

    el = null;
    vNode = null;
  };

  return { vNode, destroy, el };
};

const wrapperFix: ThisType<{ parent: any; appContext: any; provides: any }> = {
  superConstructor: function () {
    let instance = getCurrentInstance() as any;

    let provides = {};
    while (instance) {
      if (instance && instance.provides) {
        provides = { ...provides, ...instance.provides };
      }

      instance = instance.parent;
    }

    this.provides = provides;
  },

  createComponent(component: any, params: any) {
    if (!this.appContext) {
      const ctx = this.parent.$.appContext;
      this.appContext = clone(ctx);

      this.appContext.config.errorHandler = (err: unknown) => showError(err);

      const provides = {
        ...this.provides,
        ...ctx.provides,
        ...this.parent.$parent?.$options?.provide
      };

      this.appContext.provides = provides;

      // 清除static provides, 避免内存泄露
      (VueFrameworkComponentWrapper as any).provides = null;
      this.provides = null;
    }

    return VueComponentFactory.createAndMountComponent(
      component,
      params,
      this.parent,
      this.appContext
    );
  }
};

Object.setPrototypeOf(
  VueFrameworkComponentWrapper.prototype.constructor,
  (wrapperFix as any).superConstructor.prototype.constructor
);

assign(VueFrameworkComponentWrapper.prototype, wrapperFix);

/////////////////////////////////////////////////////////////////////
// BigInt
(BigInt.prototype as any).toJSON = function () {
  return this.toString();
};

////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
// 全局appContext
let appContext: AppContext | null = null;
export function getMainAppContext() {
  return appContext;
}

export default function EasyHook(
  app: App,
  options?: {
    // 租户上下文读取方法
    tenantProvider?: TenantContextProvider;

    // api协议层
    apiProtocol?: ApiProtocol | 'erp2' | 'erpy';

    // layout存储远程服务器的接口: 调整布局时调用
    remotePersistApi?: RemotePersistApi;

    // 统计埋点接口
    beaconApi?: SendBeaconHandle;

    // 提供命令权限接口
    canAccess?: CmdRightProvider;

    // ag-grid表头菜单扩展
    agHeaderContextMenu?: AgHeaderContextMenuExt<any>;

    // 页面展示元素主题控制
    uiTheme?: UiTheme;
  }
) {
  appContext = app._context;

  // 应用自定义租户上下文
  if (options?.tenantProvider) {
    setTenantContext(options.tenantProvider);
  }

  // 接口协议转换层
  if (options?.apiProtocol) {
    setApiProtocol(options.apiProtocol);
  }

  // layout远程存储接口
  if (options?.remotePersistApi) {
    setRemotePersistApi(options.remotePersistApi);
  }

  // 统计埋点接口
  if (options?.beaconApi) {
    setBeaconHandle(options.beaconApi);
  }

  // 提供权限
  if (options?.canAccess) {
    setCmdRightProvider(options.canAccess);
  }

  if (options?.agHeaderContextMenu) {
    setExtensionMenus(options.agHeaderContextMenu);
  }

  if (options?.uiTheme) {
    setUiTheme(options.uiTheme);
  }

  // 注册全局image-view
  app.directive('image-view', vImageView);
  app.directive('search-scroll-area', vSearchScrollArea);

  EyMessageBox._context = app._context;

  app.component('XelFocusTrap', (ElDrawer.components as any).ElFocusTrap);

  app.mixin({
    errorCaptured(err) {
      return showError(err);
    }
  });
}
